import RectangularCard from "./RectangularCard";
import { Row, Col } from "react-bootstrap";

import withLocalization from "../../hoc/withLocalization";

import CustomCircularProgressbar from "../ProgressBar/CircularProgressBar";

function RectangularSmallCard({ t, title, titleValue, percentage, pathColor,
    rotationStart, strokeWidth, infoText, customClassname = null }) {
    return (
        <RectangularCard backgoundClass="rectangle-card-bg-white" className={customClassname || ""} classbodyStyle={{ padding: '2px' }}>
            <Row className='align-items-center'>
                <Col xs={percentage ? 7 : 12} sm={percentage ? 7 : 12}>
                    <span className='d-flex dashboard-progressBar-header-text text-center'>
                        {t(title)}
                    </span>
                    <span className="d-flex dashboard-progressBar-header-text text-center">{t(titleValue)}</span>
                </Col>
                {percentage &&
                    <Col xs={5} sm={5}>
                        <span className='d-flex justify-content-center'>
                            <CustomCircularProgressbar
                                percentage={percentage}
                                pathColor={pathColor}
                                rotationStart={rotationStart}
                                strokeWidth={strokeWidth}
                                isStyle={true}
                            />
                        </span>
                    </Col>
                }
                {infoText &&
                    infoText
                }
            </Row>
        </RectangularCard>
    )
}
export default (withLocalization(RectangularSmallCard));